export const NONE = {
  id: "4bcb58b0-3c6c-4649-bd80-c771f8ec5e75",
  value: "None"
};
